import React from "react";

/*
 * Buttons per DESIGN.md §4.
 * primary lg: 48px, 18/28/700, radius 24 · primary md: 48px, 16/24/400
 * ghost: transparent, radius 6 · states: hover #1654A0, active #124380 + inset, 3px focus ring
 */

const BASE =
  "inline-flex items-center justify-center font-sans cursor-pointer transition-all duration-150 ease-out focus-visible:outline-none disabled:cursor-not-allowed";

const VARIANTS = {
  primary:
    "bg-ic-blue text-ic-offwhite border-0 rounded-3xl h-12 px-8 " +
    "hover:bg-ic-blueHover hover:shadow-ic-cta-hover " +
    "active:bg-ic-blueActive active:shadow-ic-inset " +
    "focus-visible:shadow-ic-focus " +
    "disabled:bg-ic-borderGray disabled:text-ic-disabledText disabled:shadow-none disabled:hover:bg-ic-borderGray disabled:hover:shadow-none",
  ghost:
    "bg-transparent text-ic-body border-0 rounded-md p-2.5 text-ic-body font-normal " +
    "hover:bg-black/5 hover:text-[#1F2937] active:bg-black/10 focus-visible:shadow-ic-focus",
};

const PRIMARY_SIZES = {
  lg: "text-[18px] leading-7 font-bold",
  md: "text-[16px] leading-6 font-normal shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]",
};

export default function Button({
  variant = "primary",
  size = "lg",
  className = "",
  children,
  ...rest
}) {
  const sizeClasses = variant === "primary" ? PRIMARY_SIZES[size] || PRIMARY_SIZES.lg : "";
  return (
    <button
      type="button"
      className={`${BASE} ${VARIANTS[variant] || VARIANTS.primary} ${sizeClasses} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
